import React from 'react';
import Classnames from 'classnames';
import { format } from 'd3';

import WeightSlider from '../Weighting/WeightSlider'

export default props => {
  const onChange = (value, method) => props.rateAnchor
    ? props.onChange(props.factor, Math.max(-1e4*props.rateAnchor,+value))
    : props.onChange(props.factor, +value)
  return (<div className={Classnames('slider', { disabled: props.disabled })}>
    <span className="factor-name">
      {props.label}
    </span>
    {props.rate
      ? <span className="factor-value">
          {`${format('.2%')(props.rateAnchor + (props.value/1e4))}`}
          {props.value !== 0 ? ` (${props.value > 0 ? "+" : ""}${format('.0f')(props.value)} bps)` : null}
        </span>
      : <span className="factor-value">
          {!!props.value ? format(props.format || '.2%')(props.value) : null}
        </span>}
    <span className="weighting-container">
      <WeightSlider
        colWidth={props.width || 230} // hard coded elsewhere
        weighting={props.value}
        previous={props.value}
        scale={props.scale}
        onChange={onChange}
      />
      {!props.rate && !props.nominmax && <div>
        <span className="min">
          {format(props.format || '.2%')(props.scale.domain()[0])}
        </span>
        <span className="max">
          {format(props.format || '.2%')(props.scale.domain()[1])}
        </span>
      </div>}
    </span>
  </div>)
}


// WEBPACK FOOTER //
// ./src/components/Column/Slider.js